import React from "react";
import ReactModal from "react-modal";

import Close from "@/assets/icon/close.svg";

ReactModal.setAppElement("#modals");

export interface ModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  title?: string;
  primaryBg?: boolean;
  className?: string;
  showCloseButton?: string;
  loading?: boolean
  children?: React.ReactNode;
}

// TODO:Timo setAppELement?

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onRequestClose,
  title,
  primaryBg,
  className,
  showCloseButton = true,
  loading = false,
  children,
}) => {
  return <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={`z-[10000] fixed inset-0 backdrop-blur-sm flex items-center justify-center motion-safe:animate-fade-modal ${primaryBg ? "ReactModal__Overlay--primary" : "" }`}
      className={`outline-none relative max-h-full ${className || ""}`}
      contentLabel={title || ""}
    >
      { loading ?
        <div className="flex flex-col justify-center items-center text-gray-200 pointer-events-none">
          <div className="loading-spinner" />
          <div className="font-bold text-center font-compressed mt-2">Inhalt wird geladen...</div>
        </div>
       :
        <div className="modal-inner-content motion-safe:animate-slide-modal-content">
            {onRequestClose && showCloseButton && (
              <div className="sticky top-0 z-20">
                <ModalCloseButton className="absolute right-0 top-0 -mt-2 -mr-2 bg-gray-50" onRequestClose={onRequestClose} />
              </div>
            )}
            {children}

        </div>
      }
      {/* </div> */}
  </ReactModal>
};

export default Modal;



export function ModalCloseButton({className, onRequestClose} : {className?: string, onRequestClose: () => void}) {
  return <button onClick={onRequestClose} className={`mobile-nav-button ${className || ""}`}>
    <Close />
  </button>
}


export function ModalTitle({className, children} : {className?: string, children:React.ReactNode}) {
  return <h2 className={`text-xl uppercase text-center font-bold ${className || ""}`}>{children}</h2>
}
